// tab type
export const ALL = "all";
export const ACTION_REQUIRED = "action_required";
export const IN_PROGRESS = "in_progress";
export const COMPLETED = "completed";

// filing status
export const NOT_STARTED = "NOT_STARTED";
export const IN_CART = "IN_CART";
export const PROCESSING = "PROCESSING";
export const FILED = "FILED";
export const SUBSCRIBED = "SUBSCRIBED";
